module.exports = __webpack_public_path__ + "media/images/flip_icon-f83c57d3.svg";